exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3LgONa7R7dKUwSgp1RRk3T{width:32px;height:32px;min-width:32px;min-height:32px;line-height:32px}html[dir] ._3LgONa7R7dKUwSgp1RRk3T{text-align:center}._2U3Mco-VY1ZMiT6mZnhwh5{color:\"[theme:white, default:#ffffff]\"}html[dir] ._3rizddd5iGRM77itj5URpy{border-radius:50%}._2up63KZs7bf06gzJdCoXud{width:28px;height:28px;min-width:28px;min-height:28px;line-height:28px}html[dir] ._2up63KZs7bf06gzJdCoXud{text-align:center}html[dir] .E1N8gh30s6gaaEsu3CynS{border-radius:4px}", ""]);
// Exports
exports.locals = {
	"container": "_3LgONa7R7dKUwSgp1RRk3T",
	"icon": "_2U3Mco-VY1ZMiT6mZnhwh5",
	"roundContainer": "_3rizddd5iGRM77itj5URpy",
	"smallContainer": "_2up63KZs7bf06gzJdCoXud",
	"squaredContainer": "E1N8gh30s6gaaEsu3CynS"
};